export var FontWeight;
(function (FontWeight) {
  FontWeight[FontWeight["REGULAR"] = 400] = "REGULAR";
  FontWeight[FontWeight["MEDIUM"] = 500] = "MEDIUM";
  FontWeight[FontWeight["BOLD"] = 700] = "BOLD";
})(FontWeight || (FontWeight = {}));